document.addEventListener("DOMContentLoaded", function() {
  var openMenuButton = document.getElementById('open-menu');
  var mobileMenuCanvas = document.getElementById('mobile-menu-canvas');

  // Função para abrir o menu
  function openMenu() {
      mobileMenuCanvas.style.left = '0';
      document.body.classList.add('menu-open');
  }

  // Função para fechar o menu
  function closeMenu() {
      mobileMenuCanvas.style.left = '-250px';
      document.body.classList.remove('menu-open');
  }

  // Evento de clique no botão para abrir/fechar o menu
  openMenuButton.addEventListener('click', function() {
      if (mobileMenuCanvas.style.left === '0px') {
          closeMenu();
      } else {
          openMenu();
      }
  });

  // Evento de clique fora do menu para fechá-lo
  document.addEventListener('click', function(e) {
      if (!mobileMenuCanvas.contains(e.target) && e.target !== openMenuButton) {
          closeMenu();
      }
  });
});